import { normalize } from "normalizr";
import type { AppQueryConfig } from "QueryTypes";
import { facilityAndSimSchema } from "./facilitySchema";
import type {
  FacilitiesEntitiesState,
  SimulatorsEntitiesState,
} from "StoreTypes";
import type { Facility } from "Models";
import { config } from "@/config/env";
import { clubhouseApiHeadersV1 } from "utils/api/apiHelper";

const urls = {
  userFacilities(userId: string): string {
    return `${config.apiBaseUrl}/api/facilities/user/${userId}`;
  },
};

export const getUserFacilitiesQuery = (userId: string): AppQueryConfig => ({
  url: urls.userFacilities(userId),
  queryKey: `getUserFacilities:${userId}`,
  options: { ...clubhouseApiHeadersV1() },
  transform: (responseJson: Facility[]) => {
    const entities = normalize(responseJson, [facilityAndSimSchema]).entities;
    // Record which facility ids this user actually owns. The `facilities` cache
    // is merged across users and other fetches, so consumers need this index to
    // scope it back to a single user rather than reading the whole cache.
    return {
      ...entities,
      facilitiesByUser: { [userId]: responseJson.map((f) => f.id) },
    };
  },
  update: {
    facilities: (oldValue, newValue): FacilitiesEntitiesState => ({
      ...oldValue,
      ...newValue,
    }),
    simulators: (oldValue, newValue): SimulatorsEntitiesState => ({
      ...oldValue,
      ...newValue,
    }),
    facilitiesByUser: (oldValue, newValue) => ({
      ...oldValue,
      ...newValue,
    }),
  },
});
